<template>
  <el-dialog
    v-if="!isMobile"
    :visible.sync="status"
    @close="close"
    :close-on-click-modal="false"
    class="login-block"
    :class="{ 'login-block-mobile': isMobile }"
  >
    <div class="title">身份验证</div>
    <div v-if="slider">
      <p class="tips">为了更好地为您服务，请您先进行简单的身份验证～</p>
      <div class="tel" :class="telStatus ? 'error' : ''">
        <input
          v-model="tel"
          @focus="telFocus"
          placeholder="请输入手机号"
          maxlength="11"
          @input="tel = tel.replace(/[^\d]/g, '')"
        />
      </div>
      <div class="verification-code">
        <input
          v-model="code"
          maxlength="6"
          @focus="codeFocus"
          @input="code = code.replace(/[^\d]/g, '')"
          placeholder="请输入短信验证码"
        />
        <span class="line"></span>
        <el-button
          class="code"
          :disabled="countDown !== 60 ? true : false"
          type="text"
          size="small"
          @click="getCode"
        >
          <span class="getCode" :style="{ color: countDown !== 60 ? '#0072F5' : '' }">{{
            countDown === 60 ? "获取验证码" : `重新获取${countDown}S`
          }}</span>
        </el-button>
      </div>
      <div class="warn" v-if="tips" :style="{ color: 'red' }">{{ tips }}</div>
      <div class="warn" v-if="codeTips" :style="{ color: '#0072F5' }">{{ codeTips }}</div>
    </div>
    <div v-else>
      <slider-verify
        ref="sliderVerify"
        :canvasWidth="300"
        :canvasHeight="150"
        @success="onSuccess"
        @fail="onFail"
        @again="onAgain"
        :failTip="failTip"
        :resTag="resTag"
      />
    </div>
    <el-button :disabled="!tag" type="primary" @click="submit">提交验证</el-button>
  </el-dialog>
</template>
<script>
import api from "@/api/index";

export default {
  name: "AuthenTication",
  data() {
    return {
      tel: "",
      code: "",
      countDown: 60,
      tips: "",
      codeTips: "",
      telStatus: false,
      failTip: "",
      captcha: {},
      isShowSliderVerify: false,
      slider: true,
      tag: false,
      resTag: 1,
    };
  },
  methods: {
    /* 滑动验证成功 */
    onSuccess(captcha) {
      this.captcha = captcha;
      this.login();
    },
    onFail(msg) {
      // if(msg) this.resTag = 2
      this.$refs.sliderVerify.isPassing = true;
    },
    onAgain() {
      this.$message("error", "滑动操作异常，请重试");
    },
    async login() {
      let res = null;
      res = await api.getImageVerifyCode(this.captcha);
      if (res.code === 0) {
        if (res.data && res.data.successFlag === -1) {
          this.$refs.sliderVerify.verifyFailEvent(res.data.errorMsg);
          return;
        }
        this.$refs.sliderVerify.verifySuccessEvent();
        this.isShowSliderVerify = false;
        this.tag = true;
        this.slider = true;
        this.resTag = 1;
        this.getCode();
      } else {
        this.slider = false;
      }
      this.isShowSliderVerify = false;
      this.resTag = 2;
    },
    close() {
      this.$store.commit("app/CHANGE_STATUS", false);
      this.tel = "";
      this.code = "";
      (this.slider = true), (this.countDown = 60), (this.tips = ""), (this.codeTips = "");
    },
    codeFocus() {
      this.tips = "";
    },
    telFocus() {
      this.tips = "";
      this.telStatus = false;
    },
    getCode() {
      this.tips = "";
      if (!this.tel) {
        this.tips = "手机号输入不能为空";
        this.telStatus = true;
        return;
      } else if (this.tel && !/^1[3456789]\d{9}$/.test(this.tel)) {
        this.tips = "请输入正确的手机号，否则无法接收验证码";
        this.telStatus = true;
        return;
      } else {
        this.code = "";
        this.isCode = true;
        this.slider = false;
        if (this.tag) {
          api.sendVerifyCode({ phoneNum: this.tel, type: "DSR_TYPE" }).then((res) => {
            if (res.code === 0) {
              this.slider = true;
              this.codeTips = "验证码已发送";
              this.timer = setInterval(() => {
                if (this.countDown === 1) {
                  this.countDown = 60;
                  this.codeTips = "";
                  this.tag = false;
                  this.resTag = 1;
                  clearInterval(this.timer);
                } else {
                  this.countDown -= 1;
                }
              }, 1000);
            } else {
              this.tips = res.msg;
              setTimeout(() => {
                this.tips = "";
              }, 3000);
            }
          });
        }
      }
    },
    submit() {
      if (!this.tel) {
        this.tips = "手机号输入不能为空";
        this.telStatus = true;
      } else if (this.tel && !/^1[3456789]\d{9}$/.test(this.tel)) {
        this.tips = "请输入正确的手机号";
      } else {
        this.loginParam = {
          userPhone: this.tel,
          type: "DSR_TYPE",
          verifyCode: this.code,
        };
        api.submitAuth(this.loginParam).then((res) => {
          if (res.code === -1) {
            this.codeTips = "";
            this.tips = res.msg.split(";").join("");
          }
          if (!res.code) {
            this.codeTips = "";
            this.setlocalstorage("token", res.data.token);
            localStorage.setItem("phone", this.tel);
            localStorage.setItem("code", this.code);
            this.$router.push("/dsr");
            this.$store.commit("app/CHANGE_STATUS", false);
          }
        });
      }
    },
    setlocalstorage(key, data) {
      // 获取当前的时间
      let FirstTime = new Date().getTime();
      // 将当前时间存储本地
      return localStorage.setItem(
        key,
        JSON.stringify({
          data,
          time: FirstTime,
        })
      );
    },
  },
  computed: {
    status: {
      get() {
        // return true;
        return this.$store.state.app.status;
      },
      set() {},
    },
  },
};
</script>

<style lang="scss">
.login-block {
  z-index: 3000;
  .el-dialog {
    width: calc(5.6px * 70);
    height: calc(5.38px * 70);
    position: relative;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__headerbtn {
      position: absolute;
      top: calc(0.35px * 70);
      right: calc(0.5px * 70);
      font-size: calc(0.215px * 70);
    }
    .el-dialog__body {
      padding: 0;
      .title {
        height: calc(0.86px * 70);
        padding: calc(0.3px * 70) 0 calc(0.18px * 70) calc(0.46px * 70);
        font-size: calc(0.25px * 70);
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      }
      .tips {
        padding: calc(0.18px * 70) calc(0.52px * 70) calc(0.276px * 70);
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: calc(0.215px * 70);
        color: rgba(0, 0, 0, 0.64);
      }
      .tel,
      .verification-code {
        position: relative;
        margin: 0 calc(0.58px * 70);
        height: calc(0.676px * 70);
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        input {
          border: 0;
          font-size: calc(0.215px * 70);
          padding-top: calc(0.2px * 70);
          padding-left: calc(0.18px * 70);
          border-radius: 3px;
        }
        .el-button {
          background: #fff !important;
          color: #262626 !important;
          position: absolute;
          right: calc(0px * 70);
          top: calc(0.12px * 70);
          width: calc(1.53px * 70);
          height: calc(0.46px * 70);
          border: 0 !important;
          padding: 0 !important;
          span {
            font-size: calc(0.21px * 70);
          }
        }
        .getCode {
          position: absolute;
          top: calc(0.1px * 70);
          left: calc(0px * 70);
          font-size: calc(0.215px * 70);
          color: #262626;
          font-family: PingFangSC-Regular, PingFang SC;
        }
      }
      .verification-code {
        margin-top: calc(0.1px * 70);
        position: relative;
        .line {
          position: absolute;
          top: calc(0.167px * 70);
          left: calc(2.7px * 70);
          height: calc(0.33px * 70);
          border: 1px solid #ccc;
        }
      }
      .el-button--primary {
        position: absolute;
        bottom: calc(0.723px * 70);
        margin: 0 calc(0.58px * 70);
        width: calc(4.46px * 70);
        height: calc(0.676px * 70);
        border-radius: 3px !important;
        span {
          font-size: calc(0.21px * 70);
          font-family: PingFangSC-Medium, PingFang SC;
        }
      }
      .warn {
        padding-left: calc(0.58px * 70);
        font-size: calc(0.184px * 70);
        padding-top: calc(0.1px * 70);
        font-family: PingFangSC-Medium, PingFang SC;
      }
      .error {
        border-color: red;
      }
    }
  }
}
</style>
